import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface KbFromBytePlugin {
  getKBFromBytes(number: number): number;
}

export default function (context: Context): KbFromBytePlugin {
  function getKBFromBytes(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number / 1024;
  }

  return { getKBFromBytes };
}
